export const SCUD_MAPPING_LIST_KEY = ['scud_mapping'];
export const SCUD_MAPPING_DETAILS_KEY = ['scud_mapping_details'];
export const SCUD_REASONS_KEY = ['scud_mapping_reasons'];
export const SCUD_REASONS_ALL_KEY = [...SCUD_REASONS_KEY, 'all'];
export const SCUD_EXCLUSIONS_KEY = ['scud_mapping_exclusions'];
